import PropTypes from 'prop-types';
import { AiFillCheckCircle, AiFillExclamationCircle } from 'react-icons/ai';
import { CardSubtitle, CardTitle } from 'reactstrap';

export default function ContractDetailsStatus({
  paidFull,
  beneficiariesDesignated,
  contractNumber,
}) {
  const getIcon = (status) => {
    if (status) {
      return <AiFillCheckCircle size={24} color="#60CF80" />;
    }
    return <AiFillExclamationCircle size={24} color="#ff0000" />;
  };
  return (
    <div className="contract-details-status">
      <CardTitle>Trust Account Details</CardTitle>
      <CardSubtitle>{`Account details as per Contract : ${contractNumber}`}</CardSubtitle>
      <table className="trust-account-details-status">
        <tbody>
          <tr>
            <td className="key">{getIcon(paidFull)}</td>
            <td className="desc">Paid in Full:</td>
            <td>{paidFull ? 'Yes' : 'No'}</td>
          </tr>
          <tr>
            <td className="key">{getIcon(beneficiariesDesignated)}</td>
            <td className="desc">Beneficiaries Designated:</td>
            <td>{beneficiariesDesignated ? 'Yes' : 'No'}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

ContractDetailsStatus.propTypes = {
  paidFull: PropTypes.bool,
  beneficiariesDesignated: PropTypes.bool.isRequired,
  contractNumber: PropTypes.string.isRequired,
};
